import React from 'react';

import { NumberFields } from 'jbc-front/components/Form';

const OrganizationNumber = ({ required }) => (
  <NumberFields
    label="労働保険番号"
    texts={['', ' - ']}
    lengths={[2, 1, 2, 6, 3]}
    required={required}
    seperateChar=""
    exactLength
    prefix="organizationNumberPart"
  />
);

export default OrganizationNumber;
